import script from "./AppDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDesktop.vue?vue&type=script&setup=true&lang=ts"

import "./AppDesktop.vue?vue&type=style&index=0&id=5e764a42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e764a42"]])

export default __exports__